import {Component, Input, ViewEncapsulation} from '@angular/core';
import {FileReferences} from '@app/models/content';
import {transition, trigger, useAnimation} from '@angular/animations';
import {slideUp} from '@app/shared/animations/slideUp';
import {slideDown} from '@app/shared/animations/slideDown';

@Component({
  selector: 'app-references',
  templateUrl: './references.component.html',
  styleUrls: ['./references.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('toggleReferences', [
      transition('void => *', [
        useAnimation(slideDown)
      ]),
      transition('* => void', [
        useAnimation(slideUp)
      ])
    ])
  ]
})
export class ReferencesComponent {

  @Input() references: FileReferences;

  showReferences = false;

  constructor() { }

  toggleReferences() {
    this.showReferences = !this.showReferences;
  }

}
